
export const FORBIDDEN_EMAIL_DOMAINS = [
    "10minute.email",
    "10minutemail.co.uk",
    "10minutemail.com",
    "10minutemail.net",
    "10minutemail.org",
    "126.com",
    "163.com",
    "188.com",
    "1secmail.com",
    "1secmail.net",
    "1secmail.org",
    "21cn.com",
    "33mail.com",
    "8alias.com",
    "aapt.net.au",
    "abv.bg",
    "accountant.com",
    "activist.com",
    "addy.io",
    "aim.com",
    "airmail.cc",
    "aleeas.com",
    "alice.it",
    "aliyun.com",
    "anonaddy.com",
    "anonaddy.me",
    "aol.co.uk",
    "aol.com",
    "aol.de",
    "aol.es",
    "aol.fr",
    "aol.it",
    "aol.jp",
    "arcor.de",
    "aruba.it",
    "asia.com",
    "att.net",
    "au.com",
    "autistici.org",
    "autorambler.ru",
    "bbox.fr",
    "bell.net",
    "bellsouth.net",
    "biglobe.ne.jp",
    "bigpond.com",
    "binkmail.com",
    "bk.ru",
    "bluewin.ch",
    "blueyonder.co.uk",
    "bobmail.info",
    "bol.com.br",
    "boun.cr",
    "bredband.net",
    "btinternet.com",
    "btopenworld.com",
    "burnermail.io",
    "c2i.net",
    "cableone.net",
    "calyxinstitute.org",
    "centrum.cz",
    "centrum.sk",
    "centurytel.net",
    "chacuo.net",
    "chammy.info",
    "charter.net",
    "cheerful.com",
    "citromail.hu",
    "claranet.fr",
    "clerk.com",
    "clix.pt",
    "club-internet.fr",
    "cock.li",
    "cockmail.com",
    "cogeco.ca",
    "comcast.net",
    "compuserve.com",
    "consolidated.net",
    "consultant.com",
    "cool.fr.nf",
    "countermail.com",
    "cox.net",
    "crazymailing.com",
    "cs.com",
    "ctemplar.com",
    "cyber-wizard.com",
    "daum.net",
    "despammed.com",
    "devnullmail.com",
    "discard.email",
    "discardmail.com",
    "discardmail.de",
    "disposeamail.com",
    "dispostable.com",
    "disroot.org",
    "dnmx.org",
    "docomo.ne.jp",
    "dodo.com.au",
    "dr.com",
    "drdrb.com",
    "dropmail.me",
    "duck.com",
    "e4ward.com",
    "earthlink.net",
    "eastlink.ca",
    "email.com",
    "email.cz",
    "email.it",
    "email.ua",
    "emailfake.com",
    "emailigo.de",
    "emailondeck.com",
    "emailsensei.com",
    "emailtemporaire.fr",
    "embarqmail.com",
    "engineer.com",
    "ephemail.net",
    "etranquil.com",
    "etranquil.net",
    "etranquil.org",
    "europe.com",
    "example.com",
    "example.net",
    "example.org",
    "excite.co.jp",
    "ezweb.ne.jp",
    "fakeinbox.com",
    "fastmail.com",
    "fastmail.fm",
    "fastwebnet.it",
    "filzmail.com",
    "fizmail.com",
    "forwardemail.net",
    "foxmail.com",
    "free.fr",
    "freemail.hu",
    "freenet.de",
    "freeserve.co.uk",
    "frontier.com",
    "fsnet.co.uk",
    "gazeta.pl",
    "get.no",
    "get2mail.fr",
    "getairmail.com",
    "getnada.com",
    "getonemail.com",
    "getonemail.net",
    "girlsundertheinfluence.com",
    "globo.com",
    "gmail.com",
    "gmx.at",
    "gmx.ch",
    "gmx.co.uk",
    "gmx.com",
    "gmx.de",
    "gmx.es",
    "gmx.fr",
    "gmx.li",
    "gmx.net",
    "gmx.us",
    "googlemail.com",
    "grandmamail.com",
    "grr.la",
    "guerrillamail.biz",
    "guerrillamail.com",
    "guerrillamail.de",
    "guerrillamail.net",
    "guerrillamail.org",
    "guerrillamailblock.com",
    "haltospam.com",
    "hanmail.net",
    "harakirimail.com",
    "hetnet.nl",
    "hide.my",
    "hidemail.de",
    "hispeed.ch",
    "home.nl",
    "hopemail.biz",
    "hotmail.be",
    "hotmail.ca",
    "hotmail.co.id",
    "hotmail.co.jp",
    "hotmail.co.th",
    "hotmail.co.uk",
    "hotmail.com",
    "hotmail.com.ar",
    "hotmail.com.au",
    "hotmail.com.br",
    "hotmail.com.mx",
    "hotmail.de",
    "hotmail.dk",
    "hotmail.es",
    "hotmail.fi",
    "hotmail.fr",
    "hotmail.it",
    "hotmail.nl",
    "hotmail.no",
    "hotmail.se",
    "hushmail.com",
    "hushmail.me",
    "i.softbank.jp",
    "i.ua",
    "icloud.com",
    "ig.com.br",
    "ihateyoualot.info",
    "iinet.net.au",
    "imails.info",
    "in.com",
    "inbox.ee",
    "inbox.lt",
    "inbox.lv",
    "inbox.ru",
    "inboxclean.com",
    "inboxclean.org",
    "inboxkitten.com",
    "incognitomail.com",
    "incognitomail.net",
    "incognitomail.org",
    "indiatimes.com",
    "infinitum.com.mx",
    "insorg-mail.info",
    "interia.pl",
    "internet.ru",
    "internode.on.net",
    "internxt.com",
    "invalid",
    "iol.pt",
    "ipoo.org",
    "irish2me.com",
    "jetable.com",
    "jetable.fr.nf",
    "jetable.net",
    "jetable.org",
    "jnxjn.com",
    "journalist.com",
    "jubii.dk",
    "juno.com",
    "kakao.com",
    "kasmail.com",
    "kaspop.com",
    "kddi.com",
    "keemail.me",
    "keepmymail.com",
    "killmail.com",
    "killmail.net",
    "klzlk.com",
    "kolabnow.com",
    "kpnmail.nl",
    "kulturbetrieb.info",
    "kurzepost.de",
    "laposte.net",
    "lawlita.com",
    "lenta.ru",
    "letthemeatspam.com",
    "lhsdv.com",
    "libero.it",
    "lifebyfood.com",
    "lineone.net",
    "link2mail.net",
    "linshiyou.com",
    "linuxmail.org",
    "list.ru",
    "litedrop.com",
    "live.at",
    "live.be",
    "live.ca",
    "live.co.uk",
    "live.co.za",
    "live.com",
    "live.com.ar",
    "live.com.au",
    "live.com.br",
    "live.com.mx",
    "live.de",
    "live.dk",
    "live.fr",
    "live.hk",
    "live.it",
    "live.nl",
    "live.no",
    "live.se",
    "localhost",
    "lol.ovpn.to",
    "lookugly.com",
    "lopl.co.cc",
    "lortemail.dk",
    "lovemeleaveme.com",
    "lr78.com",
    "m21.cc",
    "mac.com",
    "mail-filter.com",
    "mail-temporaire.fr",
    "mail.bg",
    "mail.com",
    "mail.ru",
    "mail.tm",
    "mail2rss.org",
    "mail333.com",
    "mail4trash.com",
    "mailbidon.com",
    "mailblocks.com",
    "mailbox.org",
    "mailcatch.com",
    "maildrop.cc",
    "maileater.com",
    "mailexpire.com",
    "mailfence.com",
    "mailforspam.com",
    "mailfree.ga",
    "mailfree.gq",
    "mailfree.ml",
    "mailfreeonline.com",
    "mailguard.me",
    "mailhz.me",
    "mailimate.com",
    "mailin8r.com",
    "mailinater.com",
    "mailinator.com",
    "mailincubator.com",
    "mailismagic.com",
    "mailme.ir",
    "mailme.lv",
    "mailmetrash.com",
    "mailmoat.com",
    "mailnator.com",
    "mailnesia.com",
    "mailnull.com",
    "mailo.com",
    "mailpoof.com",
    "mailsac.com",
    "mailscrap.com",
    "mailshell.com",
    "mailsiphon.com",
    "mailslite.com",
    "mailtemp.info",
    "mailtome.de",
    "mailtothis.com",
    "mailtrash.net",
    "mailzilla.com",
    "mailzilla.org",
    "mbx.cc",
    "me.com",
    "mega.zik.dj",
    "meltmail.com",
    "messagebeamer.de",
    "meta.ua",
    "mierdamail.com",
    "migmail.pl",
    "mintemail.com",
    "minutemail.com",
    "mjukgansen.com",
    "mobi.web.id",
    "mobileninja.co.uk",
    "mohmal.com",
    "moncourrier.fr.nf",
    "monemail.fr.nf",
    "monmail.fr.nf",
    "mozmail.com",
    "msn.com",
    "mt2009.com",
    "mt2014.com",
    "mt2015.com",
    "mycleaninbox.net",
    "mypartyclip.de",
    "myphantom.com",
    "myrambler.ru",
    "mysamp.de",
    "myself.com",
    "mytemp.email",
    "mytempemail.com",
    "mytrashmail.com",
    "nabala.com",
    "nada.email",
    "nada.ltd",
    "nana10.co.il",
    "nate.com",
    "naver.com",
    "netscape.net",
    "neuf.fr",
    "neverbox.com",
    "nifty.com",
    "no-spam.ws",
    "nobulk.com",
    "noclickemail.com",
    "nogmailspam.info",
    "nomail.xl.cx",
    "nomoremail.info",
    "noreply.github.com",
    "nospam.ze.tc",
    "nospamfor.us",
    "nospamthanks.info",
    "nothingtoseehere.ca",
    "notmailinator.com",
    "nowmymail.com",
    "ntlworld.com",
    "numericable.fr",
    "nurfuerspam.de",
    "nwldx.com",
    "o2.co.uk",
    "o2.pl",
    "objectmail.com",
    "obobbo.com",
    "odaymail.com",
    "one-time.email",
    "oneoffemail.com",
    "onet.pl",
    "onewaymail.com",
    "online.de",
    "online.no",
    "ono.com",
    "oopi.org",
    "op.pl",
    "optonline.net",
    "optusnet.com.au",
    "orange.co.uk",
    "orange.fr",
    "ordinaryamerican.net",
    "outlook.at",
    "outlook.be",
    "outlook.cl",
    "outlook.co.id",
    "outlook.co.il",
    "outlook.co.jp",
    "outlook.co.nz",
    "outlook.co.th",
    "outlook.co.uk",
    "outlook.com",
    "outlook.com.ar",
    "outlook.com.au",
    "outlook.com.br",
    "outlook.de",
    "outlook.dk",
    "outlook.es",
    "outlook.fr",
    "outlook.ie",
    "outlook.in",
    "outlook.it",
    "outlook.kr",
    "outlook.my",
    "outlook.ph",
    "outlook.pt",
    "outlook.sa",
    "outlook.sg",
    "owlpic.com",
    "pancakemail.com",
    "pandora.be",
    "paranoid.email",
    "passport.com",
    "pec.it",
    "pjjkp.com",
    "planet.nl",
    "plexolan.de",
    "plus.net",
    "pm.me",
    "pokemail.net",
    "pookmail.com",
    "pop.com.br",
    "post.com",
    "posteo.de",
    "posteo.eu",
    "posteo.net",
    "privacy.net",
    "privaterelay.appleid.com",
    "prodigy.net.mx",
    "proton.me",
    "protonmail.ch",
    "protonmail.com",
    "proxymail.eu",
    "prtnx.com",
    "putthisinyouremail.com",
    "pwrby.com",
    "q.com",
    "qq.com",
    "quickinbox.com",
    "r7.com",
    "rambler.ru",
    "rcpt.at",
    "reallymymail.com",
    "recode.me",
    "reconmail.com",
    "rediff.com",
    "rediffmail.com",
    "regbypass.com",
    "relay.firefox.com",
    "rhyta.com",
    "riseup.net",
    "rklips.com",
    "rmqkr.net",
    "ro.ru",
    "roadrunner.com",
    "rocketmail.com",
    "rogers.com",
    "royal.net",
    "rppkn.com",
    "rtrtr.com",
    "runbox.com",
    "safe-mail.net",
    "safersignup.de",
    "safetymail.info",
    "sandelf.de",
    "sapo.pt",
    "saynotospams.com",
    "sbcglobal.net",
    "scatmail.com",
    "schafmail.de",
    "selfdestructingmail.com",
    "sendspamhere.com",
    "seznam.cz",
    "sfr.fr",
    "sharklasers.com",
    "shaw.ca",
    "shieldemail.com",
    "shiftmail.com",
    "sify.com",
    "silomails.com",
    "simplelogin.com",
    "simplelogin.io",
    "sina.cn",
    "sina.com",
    "skeefmail.com",
    "sky.com",
    "skynet.be",
    "slaskpost.se",
    "slipry.net",
    "slmail.me",
    "slopsbox.com",
    "smailpro.com",
    "smashmail.de",
    "smellfear.com",
    "snakemail.com",
    "sneakemail.com",
    "sofimail.com",
    "softbank.ne.jp",
    "sogetthis.com",
    "sohu.com",
    "soodonims.com",
    "soverin.net",
    "spam.la",
    "spam.su",
    "spam2me.com",
    "spam4.me",
    "spamavert.com",
    "spambob.com",
    "spambob.net",
    "spambob.org",
    "spambog.com",
    "spambog.de",
    "spambog.ru",
    "spambox.info",
    "spambox.us",
    "spamcannon.com",
    "spamcannon.net",
    "spamcero.com",
    "spamcon.org",
    "spamcorptastic.com",
    "spamcowboy.com",
    "spamcowboy.net",
    "spamcowboy.org",
    "spamday.com",
    "spamex.com",
    "spamfighter.cf",
    "spamfighter.ga",
    "spamfighter.gq",
    "spamfighter.ml",
    "spamfighter.tk",
    "spamfree24.com",
    "spamfree24.de",
    "spamfree24.eu",
    "spamfree24.info",
    "spamfree24.net",
    "spamfree24.org",
    "spamgoes.in",
    "spamgourmet.com",
    "spamherelots.com",
    "spamhereplease.com",
    "spamhole.com",
    "spamify.com",
    "spaminator.de",
    "spamkill.info",
    "spaml.com",
    "spaml.de",
    "spammotel.com",
    "spamobox.com",
    "spamoff.de",
    "spamslicer.com",
    "spamspot.com",
    "spamstack.net",
    "spamtrail.com",
    "spamtrap.ro",
    "spray.no",
    "spray.se",
    "startmail.com",
    "superrito.com",
    "suremail.info",
    "sweetxxx.de",
    "sympatico.ca",
    "t-online.de",
    "tafmail.com",
    "tafoi.gr",
    "tagmymedia.com",
    "talktalk.net",
    "techie.com",
    "teewars.org",
    "telefonica.net",
    "telenet.be",
    "teleworm.com",
    "teleworm.us",
    "telia.com",
    "telmex.com",
    "telus.net",
    "temp-mail.de",
    "temp-mail.io",
    "temp-mail.org",
    "temp.emeraldcraft.com",
    "temp.headstrong.de",
    "tempail.com",
    "tempalias.com",
    "tempe4mail.com",
    "tempemail.biz",
    "tempemail.co",
    "tempemail.co.za",
    "tempemail.com",
    "tempemail.net",
    "tempinbox.co.uk",
    "tempinbox.com",
    "tempmail.com",
    "tempmail.dev",
    "tempmail.eu",
    "tempmail.gg",
    "tempmail.it",
    "tempmail.lol",
    "tempmail.plus",
    "tempmail2.com",
    "tempmailaddress.com",
    "tempmaildemo.com",
    "tempmailer.com",
    "tempmailer.de",
    "tempmailo.com",
    "tempmails.net",
    "tempomail.fr",
    "temporarioemail.com.br",
    "temporaryemail.net",
    "temporaryemail.us",
    "temporaryforwarding.com",
    "temporaryinbox.com",
    "temporarymailaddress.com",
    "tempr.email",
    "terra.com.br",
    "terra.es",
    "test.com",
    "thanksp.am",
    "thankyou2010.com",
    "thankyou2011.com",
    "thisisnotmyrealemail.com",
    "thrma.com",
    "throwam.com",
    "throwaway.email",
    "tin.it",
    "tiscali.co.uk",
    "tiscali.it",
    "tittbit.in",
    "tmail.ws",
    "tmailinator.com",
    "tmpmail.net",
    "tmpmail.org",
    "toiea.com",
    "tom.com",
    "tpg.com.au",
    "tradermail.info",
    "trash-amil.com",
    "trash-mail.at",
    "trash-mail.com",
    "trash-mail.de",
    "trash2009.com",
    "trash2010.com",
    "trash2011.com",
    "trashdevil.com",
    "trashdevil.de",
    "trashemail.de",
    "trashmail.at",
    "trashmail.com",
    "trashmail.de",
    "trashmail.io",
    "trashmail.me",
    "trashmail.net",
    "trashmail.ws",
    "trashymail.com",
    "trashymail.net",
    "trbvm.com",
    "trbvn.com",
    "trialmail.de",
    "trickmail.net",
    "turual.com",
    "tuta.com",
    "tuta.io",
    "tutanota.com",
    "tutanota.de",
    "twinmail.de",
    "tyldd.com",
    "uggsrock.com",
    "ukr.net",
    "umail.net",
    "uol.com.br",
    "upliftnow.com",
    "uplipht.com",
    "usa.com",
    "uwclub.net",
    "venompen.com",
    "verizon.net",
    "veryrealemail.com",
    "vidchart.com",
    "videotron.ca",
    "viditag.com",
    "viewcastmedia.com",
    "viewcastmedia.net",
    "viewcastmedia.org",
    "vip.126.com",
    "vip.163.com",
    "virgilio.it",
    "virginmedia.com",
    "vivaldi.net",
    "voila.fr",
    "volny.cz",
    "vomoto.com",
    "vpn.st",
    "vsimcard.com",
    "vubby.com",
    "walla.co.il",
    "walla.com",
    "wanadoo.fr",
    "wasteland.rfc822.org",
    "web.de",
    "webemail.me",
    "webm4il.info",
    "weg-werf-email.de",
    "wegwerfadresse.de",
    "wegwerfemail.com",
    "wegwerfemail.de",
    "wegwerfmail.de",
    "wegwerfmail.info",
    "wegwerfmail.net",
    "wegwerfmail.org",
    "wetrainbayarea.com",
    "wetrainbayarea.org",
    "wh4f.org",
    "whatiaas.com",
    "whatpaas.com",
    "whyspam.me",
    "wikidocuslice.com",
    "willhackforfood.biz",
    "willselfdestruct.com",
    "windowslive.com",
    "windstream.net",
    "winemaven.info",
    "wmconnect.com",
    "workmail.com",
    "wp.pl",
    "writeme.com",
    "wronghead.com",
    "wuzup.net",
    "wuzupmail.net",
    "wwwnew.eu",
    "xagloo.com",
    "xemaps.com",
    "xents.com",
    "xjoi.com",
    "xmaily.com",
    "xoxy.net",
    "xtra.co.nz",
    "ya.com",
    "ya.ru",
    "yahoo.be",
    "yahoo.ca",
    "yahoo.co.id",
    "yahoo.co.in",
    "yahoo.co.jp",
    "yahoo.co.nz",
    "yahoo.co.th",
    "yahoo.co.uk",
    "yahoo.co.za",
    "yahoo.com",
    "yahoo.com.ar",
    "yahoo.com.au",
    "yahoo.com.br",
    "yahoo.com.co",
    "yahoo.com.hk",
    "yahoo.com.mx",
    "yahoo.com.ph",
    "yahoo.com.sg",
    "yahoo.com.tw",
    "yahoo.com.vn",
    "yahoo.de",
    "yahoo.dk",
    "yahoo.es",
    "yahoo.fi",
    "yahoo.fr",
    "yahoo.gr",
    "yahoo.ie",
    "yahoo.it",
    "yahoo.nl",
    "yahoo.no",
    "yahoo.pl",
    "yahoo.ro",
    "yahoo.se",
    "yandex.com",
    "yandex.ru",
    "yandex.ua",
    "yeah.net",
    "yep.it",
    "ymail.com",
    "yogamaven.com",
    "yomail.info",
    "yopmail.com",
    "yopmail.fr",
    "yopmail.gq",
    "yopmail.net",
    "yuurok.com",
    "za.com",
    "zehnminutenmail.de",
    "zen.co.uk",
    "ziggo.nl",
    "zipmail.com.br",
    "zippymail.info",
    "zoaxe.com",
    "zoemail.org",
    "zoho.com",
    "zohomail.com",
    "zomg.info"
];
